const SubmitResult = ({ submissionStatus, formData, errorMessage, objectId }) => {
  const successMessage = (
    <>
      <h3>Seitenauswahl</h3>
      {formData.pages.all ? (
        <p>Gesamtes Dokument</p>
      ) : (
        <p>
          Seiten {formData.pages.from} bis {formData.pages.to}
        </p>
      )}
      <hr />
      <p>Die PDF Erzeugung wurde gestartet.</p>
      <p>Der Downloadlink wird an folgende E-Mail Adresse geschickt:</p>
      <p>{formData.email}</p>
    </>
  );

  const defaultErrorMessage = "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.";

  return (
    <div>
      {submissionStatus === "success" && successMessage}
      {submissionStatus === "error" && <h3>{errorMessage || defaultErrorMessage}</h3>}
      <hr />
        <p><a href={`https://viewer.onb.ac.at/${objectId}`}>Zurück zum Objekt</a></p>
    </div>
  );
};

export default SubmitResult;
